import { Box, Typography } from "@mui/material";
import { motion, useCycle } from "framer-motion";
import { type FC, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useThemePreference } from "../../theme/ThemePreferenceProvider";
import { LOGO_OPTION_BY_ID } from "../../theme/tokens";

export const LoadingFallback: FC = () => {
	const { t } = useTranslation();
	const { logo } = useThemePreference();

	const messages = useMemo(() => [t("loading.shifts"), t("preparing.schedule"), t("getting.team.ready"), t("almost.there")], [t]);

	const [currentMessage, cycleMessage] = useCycle(...messages);

	useEffect(() => {
		const interval = setInterval(cycleMessage, 2000);

		return () => clearInterval(interval);
	}, [cycleMessage]);

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "flex-start",
				height: "100%",
				gap: 3,
			}}
		>
			<Box
				component="img"
				src={LOGO_OPTION_BY_ID[logo].loading}
				alt="Logo"
				sx={{
					alignItems: "flex-start",
					width: 240,
					height: "auto",
				}}
			/>
			<Box
				sx={{
					display: "flex",
					alignItems: "flex-start",
					gap: 2,
					width: 300,
					marginLeft: 2,
				}}
			>
				<motion.img
					src={LOGO_OPTION_BY_ID[logo].spinner}
					alt="Loading"
					style={{
						width: 32,
						height: 32,
						backgroundColor: "transparent",
						mixBlendMode: "multiply",
					}}
					animate={{ rotate: [0, 360, 360] }}
					transition={{
						duration: 1,
						repeat: Infinity,
						ease: "linear",
						times: [0, 0.5, 1],
					}}
				/>
				<Typography variant="body1" sx={{ color: "black", fontSize: "20px" }}>
					{currentMessage}
				</Typography>
			</Box>
		</Box>
	);
};
